import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { TableSort } from 'components/WrappedComponents/Table/types';
import { SortOptions } from 'hooks/dossiers/useSearchDossierSummaries';
import JusticeFilterProvider from 'hooks/JusticeFilterStoreContext';
import PaginationProvider, {
  DictTablePagination,
  PAGINATION_DICT_DEFAULT,
} from 'hooks/PaginationStoreContext';
import SortProvider from 'hooks/SortStoreContext';
import { useActionsRequises } from 'hooks/useActionsRequises';
import { NOT_FOUND_PATH } from 'utils/enumData';

import DashBoard from './Dashboard';
import PageDossier from './PageDossier';

const JusticeRouter: React.FC = () => {
  const [pagination, setPagination] = useState<DictTablePagination>(
    PAGINATION_DICT_DEFAULT,
  );
  const [filter, setFilter] = useState<Partial<unknown>>({});
  const [sort, setSort] = useState<Partial<TableSort<SortOptions | undefined>>>(
    {
      IMMATRICULATION: true,
    },
  );
  const justiceActionsRequises = useActionsRequises();

  return (
    <SortProvider value={{ sort: sort, setSort: setSort }}>
      <PaginationProvider
        value={{ pagination: pagination, setPagination: setPagination }}
      >
        <JusticeFilterProvider
          value={{
            filter: filter,
            setFilter: setFilter,
            actionsRequises: justiceActionsRequises,
          }}
        >
          <Routes>
            <Route path="" element={<DashBoard />} />
            <Route path="dossier/:id" element={<PageDossier />} />
            <Route
              path="*"
              element={<Navigate replace to={NOT_FOUND_PATH} />}
            />
          </Routes>
        </JusticeFilterProvider>
      </PaginationProvider>
    </SortProvider>
  );
};

export default JusticeRouter;
